/**
 * Utility functions for Selfbook booking widget integration
 */

declare global {
  interface Window {
    bookNow?: () => void;
  }
}

/**
 * Creates a booking handler that integrates with Selfbook widget
 * Falls back to navigation if Selfbook is not available
 */
export const createSelfbookHandler = (navigate: (path: string) => void, fallbackPath: string = '/contact/') => {
  return () => {
    // Check if Selfbook widget is loaded and ready
    if (typeof window.bookNow === 'function') {
      try {
        window.bookNow();
      } catch (error) {
        console.error('Error opening Selfbook widget:', error);
        navigate(fallbackPath);
      }
    } else {
      // Fallback to contact page
      navigate(fallbackPath);
    }
  };
};